import * as loadingAction from "../../store/loading/action";
import * as messageAction from "../../store/message/action";

import { Button, CardBody, Col, Modal } from "reactstrap";
import {
  CHANGE_DATA_ON_SELECT,
  GET_DT_SOURCE_WITH_COM,
  GET_FLOW_DATA,
  GET_FLOW_DATA_MAX_MIN_10DAY,
  GET_QTY_POINT_DATA,
  SAVE_LIST_FLOW_DATA
} from "../../helpers/url_api_constant";
import React, { useEffect, useState } from "react";
import Select, {
  MultiValueGenericProps,
  MultiValueRemoveProps,
  OptionProps,
  components,
} from "react-select";
import { connect, useDispatch } from "react-redux";

import BootstrapTable from "react-bootstrap-table-next";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import PropTypes from "prop-types";
import Tooltip from "react-bootstrap/Tooltip";
import cellEditFactory from "react-bootstrap-table2-editor";
import { getPermission } from "../../helpers/auth_helper";
import moment from "moment";
import { post } from "../../helpers/api_helper";

let itemChanged = [];
let originalModelList = [];
function VirtualMeterDetail(props) {
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const [modelDeviceList, setModelDeviceList] = useState([]);
  const permission = getPermission();
  function numberFormat(number, digit = 2) {
    if (number === null || number === "null" || number === "") return "";
    function isFloat(n) {
      return Number(n) === n && n % 1 !== 0;
    }
    if (isFloat(number)) return parseFloat(number.toFixed(digit)).toLocaleString(undefined,{
      minimumFractionDigits:digit,
    });
    return parseFloat(number).toLocaleString(undefined, {
      minimumFractionDigits: digit,
    });
  }
  const addHeaderTable = () => {
    let thead = document
      .getElementById("virtual-meter-table")
      ?.getElementsByTagName("thead")[0];
    // console.log(thead);
    let tr = document.createElement("tr");
    tr.innerHTML =
      '<th colspan="4" style="border-color: #2A3042;background-color:#2A3042"></th><th colspan="3" style="text-align:center;background-color:#6478d7;color:#FFFFFF;font-size:12px;">Volume</th><th colspan="2" style="text-align:center;background-color:#556ee6;color:#FFFFFF;font-size:12px;">Heating Value</th><th colspan="3" style="text-align:center;background-color:#4362f8;color:#FFFFFF;font-size:12px;">Energy</th>';
    if (thead) thead.prepend(tr);
  };
  useEffect(() => {
    let tableId = "virtual-meter-table";
    let scrollY = 185;
    function fixedTableHeader() {
      let headerTable = document.querySelector(`#${tableId} thead`);
      if (window.scrollY >= scrollY) {
        if (headerTable) headerTable.classList.add("fixed-header");

        resizeTableHeader();
      } else {
        if (headerTable) headerTable.classList.remove("fixed-header");
      }
    }
    function resizeTableHeader() {
      setTimeout(() => {
        let headerTable = document.querySelector(`#${tableId} thead`);
        let tr = document.querySelector(`#${tableId} tbody tr`);
        if (headerTable) {
          let th = headerTable.querySelector(".header-style");
         
          if (tr) {
            for (var i = 0; i < tr.childNodes.length; i++) {
              // console.log(th.childNodes[
              //   i
              // ].style.width ,tr.childNodes[i].offsetWidth)
              th.childNodes[
                i
              ].style.width = `${tr.childNodes[i].offsetWidth}px`;
            }
          }
        }
      }, 1);
    }
    window.addEventListener("scroll", fixedTableHeader);
    document
      .querySelector(`#vertical-menu-btn`)
      .addEventListener("click", resizeTableHeader);
    return () => {
      window.removeEventListener("scroll", fixedTableHeader);
      document.querySelector(`#vertical-menu-btn`)?.removeEventListener("click", resizeTableHeader);
    };
  }, []);
  useEffect(() => {
    // console.log(props.meter?.METER_NAME);
    if (props.meter?.METER_NAME) {
      setShow(true);

      fetchData();
    }
  }, [props.meter]);
  useEffect(() => {
    if(show) addHeaderTable();
   
  }, [show]);
  const fetchData = async () => {
    setModelDeviceList([]);
    dispatch(loadingAction.showLoading());
    try {
      let [res, res2, res3,maxMin] = await Promise.all([
        post(GET_FLOW_DATA, {
          SELECT_DATE: props.selectedDate,
          METER_TYPE_FLAG: [1],
          NOMINATE_NAME: props.meter.NOMINATE_NAME,
        }),
        post(GET_DT_SOURCE_WITH_COM, {}),
        post(GET_QTY_POINT_DATA, {
          LOAD_DATE: props.selectedDate,
          METER_TYPE_FLAG: [1],
          NOMINATE_NAME: props.meter.NOMINATE_NAME,
        }),
        post(GET_FLOW_DATA_MAX_MIN_10DAY, {SELECT_DATE:props.selectedDate}),
      ]);
      let allSourceList = res2.data.dtSourceVirtualDummyWithComList;
      // console.log(allSourceList,res.data.flowDataList)
      let calculatePid = res2.data.m_SourceCaluratePID;
      let allQtyDataList = res3.data.qtyPointDataList;
      originalModelList = initialModelDataList(
        res.data.flowDataList,
        allSourceList,
        calculatePid,
        allQtyDataList,
        maxMin.data.flowMaxMinDataList
      );
      setModelDeviceList(
        initialModelDataList(
          res.data.flowDataList,
          allSourceList,
          calculatePid,
          allQtyDataList,
          maxMin.data.flowMaxMinDataList
        )
      );
    } catch (err) {
      dispatch(messageAction.showMessage(err.message));
    }
    // setTimeout(() => {
    dispatch(loadingAction.hideLoading());
    // }, 6000);
  };
  const initialModelDataList = (
    dataList,
    allSourceList,
    calculatePid,
    allQtyDataList,
    maxMinList
  ) => {
    return dataList.map(obj => {
      let maximumVolume = maxMinList.find(max=>max.METER_NAME.toLowerCase()==obj.METER_NAME.toLowerCase())?.MAX_FLOWVOLUME?.toFixed(3);
      let minimumVolume = maxMinList.find(min=>min.METER_NAME.toLowerCase()==obj.METER_NAME.toLowerCase())?.MIN_FLOWVOLUME?.toFixed(3);
      let maximumEnergy = maxMinList.find(max => max.METER_NAME.toLowerCase() == obj.METER_NAME.toLowerCase())?.MAX_FLOWENERGY?.toFixed(3);
      let minimumEnergy= maxMinList.find(min => min.METER_NAME.toLowerCase() == obj.METER_NAME.toLowerCase())?.MIN_FLOWENERGY?.toFixed(3);
      return {
        ...obj,maximumVolume,minimumVolume,maximumEnergy,minimumEnergy,
        FLOWVOLUMEREF_FLAG_CHECK_BOX:
          obj.FLOWVOLUMEREF_FLAG == 2 ? true : false,
        ENERGYREF_FLAG_CHECK_BOX: obj.ENERGYREF_FLAG == 2 ? true : false,
        FLOWVOLUME:
          obj.FLOWVOLUME === null || obj.FLOWVOLUME === ""
            ? ""
            : obj.FLOWVOLUME.toFixed(3),
        ENERGY:
          obj.ENERGY === null || obj.ENERGY === ""
            ? ""
            : obj.ENERGY.toFixed(3),
        HEATVALUE:
          obj.HEATVALUE === null || obj.HEATVALUE === ""
            ? ""
            : obj.HEATVALUE.toFixed(2),

        OptionSelected: {
          FLOWSOURCE_NAME: {
            label: obj.FLOWSOURCE_NAME,
            value: obj.FLOWSOURCE_PID,
          },
          ENERGYSOURCE_NAME: {
            label: obj.ENERGYSOURCE_NAME,
            value: obj.ENERGYSOURCE_PID,
          },
          QTYPOINT_NAME: {
            label: `${obj.QTYPOINT_NAME} ${obj.QTYPOINT_SOURCE}`,
            value: obj.HEATVALUE,
            name: obj.QTYPOINT_NAME,
            source: obj.QTYPOINT_SOURCE,
            pid: obj.QTYPOINT_PID,
          },
        },
        CalculatePid: calculatePid,
        SourceList: allSourceList
          .filter(row => row.COM_TYPE == obj.COMTYPE_NAME)
          // .filter(row => row.COM_TYPE == "RTU")
          .map(row => ({ label: row.ALIAS_NAME, value: row.PID })),
        // QtyDataList:allQtyDataList.filter(row=>(row.QTYPOINT_SOURCE=="SCADA")||(row.QTYPOINT_SOURCE=="GQMS"&&row.METER_PID==obj.METER_PID)).map(row=>({label:`${row.QTYPOINT_NAME} ${row.QTYPOINT_SOURCE}` ,value:row.QTYPOINT_VALUE,pid:row.QTYPOINT_PID,source:row.QTYPOINT_SOURCE,name:row.QTYPOINT_NAME}))
        QtyDataList: [
          ...allSourceList
            .filter(
              function (row) {
                if (this.count < 1 && row.ALIAS_NAME == "Manual") {
                  this.count++;
                  return true;
                }
                return false;
              },
              { count: 0 }
            )
            .map(row => ({
              label: row.ALIAS_NAME,
              value: "",
              pid: row.PID,
              name: row.ALIAS_NAME,
              source: row.ALIAS_NAME,
            })),
          ...allQtyDataList
            .filter(row => row.QTYPOINT_SOURCE == "SCADA")
            .sort((a, b) =>
              a.QTYPOINT_NAME > b.QTYPOINT_NAME
                ? 1
                : b.QTYPOINT_NAME > a.QTYPOINT_NAME
                ? -1
                : 0
            )
            .map(row => ({
              label: `${row.QTYPOINT_NAME} ${row.QTYPOINT_SOURCE}`,
              value: row.QTYPOINT_VALUE,
              pid: row.QTYPOINT_PID,
              name: row.QTYPOINT_NAME,
              source: row.QTYPOINT_SOURCE,
            })),
          ...allQtyDataList
            .filter(row => row.QTYPOINT_SOURCE != "SCADA")
            .sort((a, b) =>
              a.QTYPOINT_NAME > b.QTYPOINT_NAME
                ? 1
                : b.QTYPOINT_NAME > a.QTYPOINT_NAME
                ? -1
                : 0
            )
            .map(row => ({
              label: `${row.QTYPOINT_NAME} ${row.QTYPOINT_SOURCE}`,
              value: row.QTYPOINT_VALUE,
              pid: row.QTYPOINT_PID,
              name: row.QTYPOINT_NAME,
              source: row.QTYPOINT_SOURCE,
            })),
        ],
      };
    });
  };
  const compareOriginalData = (value, other) => {
    // Get the value type
    var type = Object.prototype.toString.call(value);
    // If the two objects are not the same type, return false
    if (type !== Object.prototype.toString.call(other)) return false;

    // If items are not an object or array, return false
    if (["[object Array]", "[object Object]"].indexOf(type) < 0) return false;

    // Compare the length of the length of the two items
    var valueLen =
      type === "[object Array]" ? value.length : Object.keys(value).length;
    var otherLen =
      type === "[object Array]" ? other.length : Object.keys(other).length;
    if (valueLen !== otherLen) return false;

    // Compare two items
    var compare = function (item1, item2) {
      // Get the object type
      var itemType = Object.prototype.toString.call(item1);

      // If an object or array, compare recursively
      if (["[object Array]", "[object Object]"].indexOf(itemType) >= 0) {
        if (!compareOriginalData(item1, item2)) return false;
      }

      // Otherwise, do a simple comparison
      else {
        // If the two items are not the same type, return false
        // console.log(itemType , Object.prototype.toString.call(item2))
        // if (itemType !== Object.prototype.toString.call(item2)) return false;
        // if (item1 != item2) return false;

        // Else if it's a function, convert to a string and compare
        // Otherwise, just compare
        if (itemType === "[object Function]") {
          if (item1.toString() !== item2.toString()) return false;
        } else {
          if (item1 != item2) return false;
        }
      }
    };

    // Compare properties
    if (type === "[object Array]") {
      for (var i = 0; i < valueLen; i++) {
        if (compare(value[i], other[i]) === false) itemChanged.push(other[i]);
      }
    } else {
      for (var key in value) {
        if (value.hasOwnProperty(key)) {
          if (compare(value[key], other[key]) === false) return false;
        }
      }
    }

    // If nothing failed, return true
    return true;
  };
  const back = () => {
    setShow(false);
    setModelDeviceList([]);
    props.setVirtualMeter({});
  };
  const saveData = async () => {
    dispatch(loadingAction.showLoading());
    itemChanged = [];
    compareOriginalData(originalModelList, modelDeviceList);
    let dataEdited = [...itemChanged];
    if(dataEdited.length == 0) {
      dispatch(messageAction.showMessage("No data changed."));
      dispatch(loadingAction.hideLoading());
      return;
    }
    try {
      let res = await post(SAVE_LIST_FLOW_DATA, dataEdited);
      if (res.resultCode == 200) {
        back();
        dispatch(messageAction.showMessage("Save success."));
      } else {
        dispatch(messageAction.showMessage(res.resultDescription));
      }
    } catch (err) {
      dispatch(messageAction.showMessage(err.message));
    }
    dispatch(loadingAction.hideLoading());
  };

  const volumeCalculate = async data => {
    let resNom = await post(CHANGE_DATA_ON_SELECT, {
      ...data,
      SOURCE_NAME: "Nomination",
    });
    // resNom.data.objData.ENERGY =10000
    setModelDeviceList(prevData => {
      return prevData.map(item => {
        if (
          item.FLOWSOURCE_NAME == "Nomination" &&
          item.METER_NAME == data.METER_NAME
        ) {
          if (
            resNom.data.objData.ENERGY != "" &&
            item.HEATVALUE != ""
          ) {
            item.SHOW_FLOWVOLUME = (
              resNom.data.objData.ENERGY / item.HEATVALUE
            ).toFixed(3);
            item.FLOWVOLUME = (
              resNom.data.objData.ENERGY / item.HEATVALUE
            ).toFixed(3);
          } else {
            item.SHOW_FLOWVOLUME = "";
            item.FLOWVOLUME = "";
          }
        }
        return { ...item };
      });
    });
  };
  const rowStyleFontWhite = (row, rowIndex) => {
    const style = {};
    // style.fontWeight = 'bold';
    style.color = "white";

    return style;
  };

  const CountIndexRow = (cell, row, rowIndex) => rowIndex + 1;
  const flowVolumeStatus = (cellContent, row) => {
    // console.log(row);
    let color;
    if (row.FLOWVOLUME_STATUS == 1) {
      color = "#109600";
    } else if (row.FLOWVOLUME_STATUS == 2) {
      color = "#FCF400";
    } else {
      color = "#FF0101";
    }
    return (
      <div className="form-check-danger">
        {" "}
        {/* <div className="form-check form-check-primary"> */}{" "}
        <i
          className="mdi mdi-circle align-middle mb-2"
          style={{ color: color }}
        ></i>{" "}
        {color == "#FF0101" && (
          <input
            // style={{ margin: '0px',padding:'0px' }}
            type="checkbox"
            className="form-check-input p-0 mt-1 m-0 ms-2"
            checked={row.FLOWVOLUMEREF_FLAG_CHECK_BOX}
            onChange={() => {
              setModelDeviceList(prevData => {
                return prevData.map(item => {
                  if (row.PID == item.PID) {
                    return {
                      ...item,
                      FLOWVOLUMEREF_FLAG_CHECK_BOX:
                        !item.FLOWVOLUMEREF_FLAG_CHECK_BOX,
                    };
                  }
                  return { ...item };
                });
              });
            }}
          />
        )}{" "}
        {/* </div> */}{" "}
      </div>
    );
  };
  const defaultSorted = [
    {
      dataField: "METER_NAME",
      order: "asc",
    },
  ];
  const enegyCalculate = () => {
    setModelDeviceList(prevData => {
      return prevData.map(item => {
        if (item.ENERGYSOURCE_NAME == "Calculate") {
          if (item.FLOWVOLUME != "" && item.HEATVALUE != "") {
            item.SHOW_ENERGY = (item.FLOWVOLUME * item.HEATVALUE).toFixed(3);
            item.ENERGY = (item.FLOWVOLUME * item.HEATVALUE).toFixed(3);
          } else {
            item.SHOW_ENERGY = "";
            item.ENERGY = "";
          }
        }
        return { ...item };
      });
    });
  };
  const changeDataOnInput = async (data, row, flag) => {
    
    dispatch(loadingAction.showLoading());
    try {
      // console.log(data,flag)
      let res = await post(CHANGE_DATA_ON_SELECT, data);

      // console.log(res);
      setModelDeviceList(prevData => {
        return prevData.map(item => {
          if (item.PID === row.PID) {
            if (item.ENERGYSOURCE_NAME == "Calculate") {
              item.SHOW_ENERGY = item.FLOWVOLUME * item.HEATVALUE;
              item.ENERGY = item.FLOWVOLUME * item.HEATVALUE;
            }
            if (flag == 1) {
              return {
                ...item,
                ...(data.SOURCE_NAME != "Nomination" && {
                  SHOW_FLOWVOLUME:
                    res.data.objData.VOLUME === null
                      ? ""
                      : res.data.objData.VOLUME,
                  FLOWVOLUME:
                    res.data.objData.VOLUME === null
                      ? ""
                      : res.data.objData.VOLUME,
                }),
              };
            } else if (flag == 2) {
              return {
                ...item,
                HEATVALUE:
                  res.data.objData.HEATING === null
                    ? null
                    : res.data.objData.HEATING,
              };
            } else {
              return {
                ...item,
                SHOW_ENERGY:
                  res.data.objData.ENERGY === null
                    ? ""
                    : res.data.objData.ENERGY,
                ENERGY:
                  res.data.objData.ENERGY === null
                    ? ""
                    : res.data.objData.ENERGY,
              };
            }
          }
          return { ...item };
        });
      });
      enegyCalculate();
      if (row.FLOWSOURCE_NAME == "Nomination" || data.SOURCE_NAME) {
        volumeCalculate(data);
      }
      // volumeCalculate(resNom.data.objData);
      if (res.resultCode != 200) {
        dispatch(messageAction.showMessage(res.resultDescription));
      }
    } catch (err) {
      dispatch(messageAction.showMessage(err.message));
    }
    dispatch(loadingAction.hideLoading());
  };
  const handleSelectDropDownVolumeInput = (selected, row) => {
    let flag = 1;

    setModelDeviceList(prevData => {
      return prevData.map(item => {
        if (item.PID === row.PID) {
          let status = {};
          if (selected.label == item.FLOWSOURCEREF_NAME)
            status = { FLOWVOLUME_STATUS: item.FLOWVOLUMEREF_STATUS };
          return {
            ...item,
            ...status,
            // ...(selected.label!=item.FLOWSOURCEREF_NAME&&item.FLOWVOLUME_STATUS==item.FLOWVOLUMEREF_STATUS&&{FLOWVOLUME_STATUS:item.FLOWVOLUMEOLD_STATUS,FLOWVOLUMEOLD_STATUS:null}),
            FLOWSOURCE_NAME: selected.label,
            FLOWSOURCE_PID: selected.value,
            OptionSelected: {
              ...item.OptionSelected,
              FLOWSOURCE_NAME: selected,
            },
          };
        }
        return { ...item };
      });
    });
    let data = {
      METER_NAME: row.METER_NAME,
      SOURCE_NAME: selected.label,
      LOAD_DATE: moment(row.SELECT_DATE).format("YYYY-MM-DD"),
    };

    changeDataOnInput(data, row, flag);
  };
  const DropDrownVolumeInput = (cellContent, row) => {
    // console.log(row)
    return (
      <div>
        <Select
          value={cellContent}
          onChange={selected => handleSelectDropDownVolumeInput(selected, row)}
          options={row.SourceList}
          classNamePrefix="select2-selection"
        />
      </div>
    );
  };
  const CheckStatusManualVolumeData = (cellContent, row) => {
    if (row.FLOWVOLUME == null) {
      cellContent = "";
    } else {
      cellContent = row.FLOWVOLUME;
    }
    let color;
    if (row.FLOWVOLUMEREF_STATUS < row.FLOWVOLUME_STATUS) {
      if (row.FLOWVOLUMEREF_STATUS == 1) {
        color = "#109600";
      } else if (row.FLOWVOLUMEREF_STATUS == 2) {
        color = "#FCF400";
      }
    }
    let maxMinIcon 
    if(row.FLOWVOLUME!=""&&row.FLOWVOLUME!=undefined&&row.FLOWVOLUME!=null){
      if(parseFloat(row.FLOWVOLUME)>parseFloat(row.maximumVolume)||parseFloat(row.FLOWVOLUME)<parseFloat(row.minimumVolume)){
        if(parseFloat(row.FLOWVOLUME)>parseFloat(row.maximumVolume)){
          // console.log(parseFloat(row.FLOWVOLUME)>parseFloat(row.maximumVolume),parseFloat(row.FLOWVOLUME),parseFloat(row.maximumVolume))
          maxMinIcon="fas fa-arrow-up"
          // console.log(row.METER_NAME,"up",row.FLOWVOLUME,row.maximumVolume,row)
        }else {
          maxMinIcon="fas fa-arrow-down"
          // console.log(row.METER_NAME,"down",row.FLOWVOLUME,row.minimumVolume,row)
        }
      }
     
    }
    return (
      <div className="justify-content-between">
        {" "}
        {row.FLOWSOURCE_NAME == "Manual" && (
    <i className="fas fa-edit" style={{ float: "left" ,marginRight:"0.2rem"}}>
            {" "}
          </i>
        )}{" "}
        {maxMinIcon&&( 
            <OverlayTrigger
            placement="bottom-end"
            overlay={
              <Tooltip id="tooltip-minmax">
                <p style={{ fontSize: 14 }}>
               
                  10 Day Min :{" "}
                  {numberFormat(row.minimumVolume, 3)}
                </p>
                <p style={{ fontSize: 14 }}>
               
                  10 Day Max :{" "}
                  {numberFormat(row.maximumVolume, 3)}
                </p>
              </Tooltip>
            }
          >
              <i className={maxMinIcon} style={{ float: "left" ,color:'rgb(255, 1, 1)'}}></i>
          </OverlayTrigger>
          )}
        {numberFormat(cellContent, 3)}{" "}
        {row.FLOWVOLUMEREF_STATUS < row.FLOWVOLUME_STATUS &&
          row.FLOWSOURCEREF_NAME != row.FLOWSOURCE_NAME && (
            <OverlayTrigger
              placement="bottom-end"
              overlay={
                <Tooltip id="tooltip-disabled">
                  <strong style={{ fontSize: 15 }}>
                    <i
                      className="mdi mdi-circle align-middle mb-2"
                      style={{ color: color }}
                    ></i>{" "}
                    {row.FLOWSOURCEREF_NAME} :{" "}
                    {numberFormat(row.FLOWVOLUMEREF, 3)}
                  </strong>
                </Tooltip>
              }
            >
              <i
                className="fas fa-exclamation-circle"
                style={{ color: color }}
                onClick={() => {
                  dispatch(
                    confirmAction.showConfirm(
                      "Do you want to change to current data ?",
                      () => {
                        handleSelectDropDownVolumeInput(
                          row.SourceList.find(
                            item => item.label == row.FLOWSOURCEREF_NAME
                          ),
                          row
                        );
                      }
                    )
                  );
                }}
              ></i>
            </OverlayTrigger>
          )}
      </div>
    );
  };
  const DropDrownQualityPoint = (cellContent, row) => {
    return (
      <div>
        <Select
          value={cellContent}
          onChange={selected => handleSelectDropDownQualityPoint(selected, row)}
          options={row.QtyDataList}
          components={{ Option: QtyOption }}
          classNamePrefix="select2-selection"
          styles={qtyOptionStyle}
        />
      </div>
    );
  };
  const qtyOptionStyle = {
    menu: (provided, state) => ({
      ...provided,
      width: 270,
    }),
  };

  const QtyOption = (props: OptionProps) => {
    const { label, value } = props;
    return (
      <components.Option {...props}>
        {props.label}{" "}
        {value && (
          <span style={{ fontSize: "10px", color: "#a6b0cf" }}>
            ({props.value})
          </span>
        )}
      </components.Option>
    );
  };
  const CheckHeatingValue = (cellContent, row) => {
    if (row.HEATVALUE == null) {
      cellContent = "";
    } else {
      cellContent = row.HEATVALUE;
    }
    return (
      <div className="justify-content-between">
        {" "}
        {row.QTYPOINT_SOURCE == "Manual" && (
          <i className="fas fa-edit" style={{ float: "left" }}>
            {" "}
          </i>
        )}{" "}
        {numberFormat(cellContent, 2)}{" "}
      </div>
    );
  };
  const handleSelectDropDownEnergyInput = (selected, row) => {
    let flag = 3;
    setModelDeviceList(prevData => {
      return prevData.map(item => {
        if (item.PID === row.PID) {
          let status = {};
          if (selected.label == item.ENERGYSOURCEREF_NAME)
            status = { ENERGY_STATUS: item.ENERGYREF_STATUS };
          // if(selected.label!=item.ENERGYSOURCEREF_NAME&&item.ENERGYREF_STATUS!=item.ENERGYREF_STATUS)status={ENERGY_STATUS:item.ENERGYOLD_STATUS,ENERGYOLD_STATUS:null}
          return {
            ...item,
            ...status,
            ENERGYSOURCE_NAME: selected.label,
            ENERGYSOURCE_PID: selected.value,
            OptionSelected: {
              ...item.OptionSelected,
              ENERGYSOURCE_NAME: selected,
            },
          };
        }
        return { ...item };
      });
    });
    let data = {
      METER_NAME: row.METER_NAME,
      SOURCE_NAME: selected.label,
      LOAD_DATE: moment(row.SELECT_DATE).format("YYYY-MM-DD"),
    };
    changeDataOnInput(data, row, flag);
  };
  const handleSelectDropDownQualityPoint = (selected, row) => {
    setModelDeviceList(prevData => {
      return prevData.map(item => {
        if (item.PID === row.PID) {
          // console.log(item);
          return {
            ...item,
            QTYPOINT_NAME: selected.name,
            QTYPOINT_PID: selected.pid,
            QTYPOINT_SOURCE: selected.source,
            HEATVALUE: selected.value == "" ? 0 : selected?.value?.toFixed(2),
            OptionSelected: { ...item.OptionSelected, QTYPOINT_NAME: selected },
          };
        }
        return { ...item };
      });
    });
    enegyCalculate();
    if (row.FLOWSOURCE_NAME == "Nomination") {
      let data = {
        METER_NAME: row.METER_NAME,
        SOURCE_NAME: selected.label,
        LOAD_DATE: moment(row.SELECT_DATE).format("YYYY-MM-DD"),
      };
      volumeCalculate(data);
    }
  };
  const DropDrownEnergyInput = (cellContent, row) => {
    // console.log(row);
    return (
      <div>
        <Select
          value={cellContent}
          onChange={selected => handleSelectDropDownEnergyInput(selected, row)}
          options={[
            ...row.SourceList,
            { label: "Calculate", value: row.CalculatePid },
          ]}
          classNamePrefix="select2-selection"
        />
      </div>
    );
  };
  const energyStatus = (cellContent, row) => {
    let color;
    if (row.ENERGY_STATUS == 1) {
      color = "#109600";
    } else if (row.ENERGY_STATUS == 2) {
      color = "#FCF400";
    } else {
      color = "#FF0101";
    }
    // console.log(row.ENERGYREF_FLAG_CHECK_BOX)
    return (
      <div className="form-check-danger">
        {" "}
        {/* <div className="form-check form-check-primary"> */}{" "}
        <i
          className="mdi mdi-circle align-middle mb-2"
          style={{ color: color }}
        ></i>{" "}
        {color == "#FF0101" && (
          <input
            // style={{ margin: '0px',padding:'0px' }}
            type="checkbox"
            className="form-check-input p-0 mt-1 m-0 ms-2"
            checked={row.ENERGYREF_FLAG_CHECK_BOX}
            onChange={e => {
              setModelDeviceList(prevData => {
                return prevData.map(item => {
                  if (row.PID == item.PID) {
                    return {
                      ...item,
                      ENERGYREF_FLAG_CHECK_BOX: !item.ENERGYREF_FLAG_CHECK_BOX,
                    };
                  }
                  return { ...item };
                });
              });
            }}
          />
        )}{" "}
        {/* </div> */}{" "}
      </div>
    );
  };
  const CheckStatusManualEnergyData = (cellContent, row) => {
    let color;
    if (row.ENERGYREF_STATUS < row.ENERGY_STATUS) {
      if (row.ENERGYREF_STATUS == 1) {
        color = "#109600";
      } else if (row.ENERGYREF_STATUS == 2) {
        color = "#FCF400";
      }
    }
    // console.log(row)
    if (row.ENERGY == null) {
      cellContent = "";
    } else {
      cellContent = row.ENERGY;
    }
    let maxMinIcon
    if (row.ENERGY != "" && row.ENERGY != undefined && row.ENERGY != null) {
      if (parseFloat(row.ENERGY) > parseFloat(row.maximumEnergy) || parseFloat(row.ENERGY) < parseFloat(row.minimumEnergy)) {
        if (parseFloat(row.ENERGY) > parseFloat(row.maximumEnergy)) {
          
          maxMinIcon = "fas fa-arrow-up"
         
        } else {
          maxMinIcon = "fas fa-arrow-down"
         
        }
      }

    }
    return (
      <div className="justify-content-between">
        {" "}
        {row.ENERGYSOURCE_NAME == "Manual" && (
          <i className="fas fa-edit" style={{ float: "left" }}>
            {" "}
          </i>
        )}{" "}
        {maxMinIcon && (
          <OverlayTrigger
            placement="bottom-end"
            overlay={
              <Tooltip id="tooltip-energy-minmax">
                <p style={{ fontSize: 14 }}>

                  10 Day Min :{" "}
                  {numberFormat(row.minimumEnergy, 3)}
                </p>
                <p style={{ fontSize: 14 }}>

                  10 Day Max :{" "}
                  {numberFormat(row.maximumEnergy, 3)}
                </p>
              </Tooltip>
            }
          >
            <i className={maxMinIcon} style={{ float: "left", color: 'rgb(255, 1, 1)' }}></i>
          </OverlayTrigger>
        )}
        {numberFormat(cellContent, 3)}{" "}
        {row.ENERGYREF_STATUS < row.ENERGY_STATUS &&
          row.ENERGYSOURCE_NAME != row.ENERGYSOURCEREF_NAME && (
            <OverlayTrigger
              placement="bottom-end"
              overlay={
                <Tooltip id="tooltip-disabled">
                  <strong style={{ fontSize: 15 }}>
                    <i
                      className="mdi mdi-circle align-middle mb-2"
                      style={{ color: color }}
                    ></i>{" "}
                    {row.ENERGYSOURCEREF_NAME} :{" "}
                    {numberFormat(row.ENERGYREF, 3)}
                  </strong>
                </Tooltip>
              }
            >
              <i
                className="fas fa-exclamation-circle"
                style={{ color: color }}
                onClick={() => {
                  dispatch(
                    confirmAction.showConfirm(
                      "Do you want to change to current data ?",
                      () => {
                        handleSelectDropDownEnergyInput(
                          row.SourceList.find(
                            item => item.label == row.ENERGYSOURCEREF_NAME
                          ),
                          row
                        );
                      }
                    )
                  );
                }}
              ></i>
            </OverlayTrigger>
          )}
      </div>
    );
  };
  const columns = [
    {
      dataField: "Dummy",
      text: "No.",
      headerAlign: "center",
      editable: false,
      align: "center",
      headerStyle: {
        backgroundColor: "#7E8EDA",
        width: "2%",
        fontSize: "12px",
      },
      style: {
        width: "2%",
      },
      formatter: CountIndexRow,
    },
    {
      dataField: "METER_NAME",
      text: "Customer",
      headerAlign: "center",
      editable: false,
      align: "center",
      headerStyle: {
        backgroundColor: "#7E8EDA",
        width: "9%",
        fontSize: "12px",
      },
      style: {
        width: "9%",
      },
      sort: true,
    },
    {
      dataField: "METER_TYPE",
      text: "Customer Type",
      headerAlign: "center",
      editable: false,
      align: "center",
      headerStyle: {
        backgroundColor: "#7E8EDA",
        width: "9%",
        fontSize: "12px",
      },
      style: {
        width: "9%",
      },
      sort: true,
    },
    {
      dataField: "COMTYPE_NAME",
      text: "Communication Type",
      headerAlign: "center",
      editable: false,
      align: "center",
      headerStyle: {
        backgroundColor: "#7E8EDA",
        width: "9%",
        fontSize: "12px",
      },
      style: {
        width: "9%",
      },
      sort: true,
    },
    {
      dataField: "FLOWVOLUME_STATUS",
      formatter: flowVolumeStatus,
      headerAlign: "center",
      editable: false,
      sort: true,
      align: "center",
      text: "Status",
      headerStyle: {
        backgroundColor: "#6478d7",
        width: "8%",
        fontSize: "12px",
      },
      style: {
        width: "8%",
      },
      // sort: true,
    },
    {
      dataField: "OptionSelected.FLOWSOURCE_NAME",
      formatter: DropDrownVolumeInput,
      text: "Input",
      headerAlign: "center",
      editable: false,
      align: "center",
      headerStyle: {
        backgroundColor: "#6478d7",
        width: "10%",
        fontSize: "12px",
      },
      style: {
        width: "10%",
      },
      // sort: true,
    },

    {
      dataField: "FLOWVOLUME",
      formatter: CheckStatusManualVolumeData,
      text: "Data",

      editable: (content, row, rowIndex, columnIndex) =>
        row.FLOWSOURCE_NAME == "Manual",
      headerAlign: "center",
      align: "right",
      headerStyle: {
        backgroundColor: "#6478d7",
        width: "8%",
        fontSize: "12px",
      },
      style: (cell, row, rowIndex, colIndex) => {
        if (row.FLOWSOURCE_NAME == "Manual") {
          return {
            width: "8%",
            cursor: "pointer",
          };
        }
        return {
          width: "8%",
          cursor: "default",
        };
      },
      // style: {
      //   width: "8%",
      // },
      // sort: true,
      validator: (newValue, row, column, done) => {
        setTimeout(() => {
          if (isNaN(newValue)) {
            return done({
              valid: false,
              message: "Should be numeric",
            });
          }
          return done();
        }, 0);
        return {
          async: true,
        };
      },
    },
    {
      dataField: "OptionSelected.QTYPOINT_NAME",
      formatter: DropDrownQualityPoint,
      text: "Quality Point",
      editable: false,
      headerAlign: "center",
      align: "center",
      headerStyle: {
        backgroundColor: "#556ee6",
        width: "11%",
        fontSize: "12px",
      },
      style: {
        width: "11%",
      },
      // sort: true,
    },
    {
      dataField: "HEATVALUE",
      formatter: CheckHeatingValue,
      editable: (content, row, rowIndex, columnIndex) =>
        row.QTYPOINT_NAME == "Manual",
      text: "Data",
      headerAlign: "center",
      align: "right",
      headerStyle: {
        backgroundColor: "#556ee6",
        width: "8%",
        fontSize: "12px",
      },
      style: (cell, row, rowIndex, colIndex) => {
        if (row.QTYPOINT_NAME == "Manual") {
          return {
            width: "8%",
            cursor: "pointer",
          };
        }
        return {
          width: "8%",
          cursor: "default",
        };
      },
      // style: {
      //   width: "8%",
      // },
      // sort: true,
      validator: (newValue, row, column, done) => {
        setTimeout(() => {
          if (isNaN(newValue)) {
            return done({
              valid: false,
              message: "Should be numeric",
            });
          }
          return done();
        }, 0);
        return {
          async: true,
        };
      },
    },
    {
      dataField: "ENERGY_STATUS",
      formatter: energyStatus,
      editable: false,
      sort: true,
      // sortFunc: (a, b, order, dataField) => {
      //   if (order === 'asc') {
      //     return b.value - a.value;
      //   }
      //   return a.value - b.value; // desc
      // },
      text: "Status",
      headerAlign: "center",
      align: "center",
      headerStyle: {
        backgroundColor: "#4362f8",
        // color: "#FFFFFF",
        width: "8%",
        fontSize: "12px",
      },
      style: {
        width: "8%",
      },
    },
    {
      dataField: "OptionSelected.ENERGYSOURCE_NAME",
      formatter: DropDrownEnergyInput,
      text: "Input",
      editable: false,
      headerAlign: "center",
      align: "center",
      headerStyle: {
        backgroundColor: "#4362f8",
        // color: "#FFFFFF",
        width: "10%",
        fontSize: "12px",
      },
      style: {
        width: "10%",
      },
      // sort: true,
    },
    {
      dataField: "ENERGY",
      formatter: CheckStatusManualEnergyData,
      text: "Data",
      editable: (content, row, rowIndex, columnIndex) =>
        row.ENERGYSOURCE_NAME == "Manual",
      headerAlign: "center",
      align: "right",
      headerStyle: {
        backgroundColor: "#4362f8",
        width: "8%",
        fontSize: "12px",
      },
      style: (cell, row, rowIndex, colIndex) => {
        if (row.ENERGYSOURCE_NAME == "Manual") {
          return {
            width: "8%",
            cursor: "pointer",
          };
        }
        return {
          width: "8%",
          cursor: "default",
        };
      },
      // style: {
      //   width: "8%",
      // },
      validator: (newValue, row, column, done) => {
        setTimeout(() => {
          if (isNaN(newValue)) {
            return done({
              valid: false,
              message: "Should be numeric",
            });
          }
          return done();
        }, 0);
        return {
          async: true,
        };
      },
      // sort: true,
    },
  ];
  return (
    <>
      {show && (
        <CardBody>
          <div className="page-title-box d-sm-flex align-items-center justify-content-between">
            <h1 className="mb-sm-0 font-size-20">
              Virsual Meter Detail : {props.meter?.METER_NAME}
            </h1>
            <Button
              onClick={() => {
                back();
              }}
              // className="btn-rounded"
              color="secondary"
              className="mt-2 mb-2"
            >
              <i className="fas fa-angle-double-left"></i>
              &nbsp; Back
            </Button>
          </div>
          <hr />
          <BootstrapTable
            id="virtual-meter-table"
            keyField="PID"
            data={modelDeviceList}
            columns={columns}
            defaultSorted={defaultSorted}
            headerClasses="header-style"
            rowStyle={rowStyleFontWhite}
            cellEdit={cellEditFactory({
              mode: "click",
              blurToSave: true,
              afterSaveCell: (oldValue, newValue, row, column) => {
                enegyCalculate();
                if (row.FLOWSOURCE_NAME == "Nomination") {
                  let data = {
                    METER_NAME: row.METER_NAME,
                    SOURCE_NAME: "Nomination",
                    LOAD_DATE: moment(row.SELECT_DATE).format("YYYY-MM-DD"),
                  };
                  volumeCalculate(data);
                }
              },
            })}
          />
          <Col
            sm="12"
            className="d-flex align-items-center justify-content-end"
          >
            <div className="d-grid gap-2 d-md-block">
              {permission.eFSN && (
              <Button
                onClick={() => saveData()}
                color="success"
                className="btn w-md"
              >
                <i className="fab fa-firstdraft"> </i> &nbsp; Save{" "}
              </Button>
              )}
            </div>
          </Col>
        </CardBody>
      )}
    </>
    // <Modal size="xl" isOpen={show} scrollable={true}>

    //   <div className="modal-header">
    //     <h5 className="modal-title">EOD</h5>
    //   </div>
    //   <div className="modal-body">
    //     <BootstrapTable
    //       id="virtual-meter-table"
    //       keyField="PID"
    //       data={modelDeviceList}
    //       columns={columns}
    //       defaultSorted={defaultSorted}
    //       headerClasses="header-style"
    //       rowStyle={rowStyleFontWhite}
    //       cellEdit={cellEditFactory({
    //         mode: "click",
    //         blurToSave: true,
    //         afterSaveCell: (oldValue, newValue, row, column) => {
    //           enegyCalculate();
    //           if (row.FLOWSOURCE_NAME == "Nomination") {
    //             let data = {
    //               METER_NAME: row.METER_NAME,
    //               SOURCE_NAME: "Nomination",
    //               LOAD_DATE: moment(row.SELECT_DATE).format("YYYY-MM-DD"),
    //             };
    //             volumeCalculate(data);
    //           }
    //         },
    //       })}
    //     />
    //   </div>
    //   <div className="modal-footer">
    //     <button
    //       type="button"
    //       className="btn btn-success"
    //       onClick={() => close()}
    //     >
    //       {/* <i className="fas fa-times"></i> */}
    //       {/* &nbsp;  */}
    //       OK
    //     </button>
    //   </div>
    // </Modal>
  );
}

VirtualMeterDetail.propTypes = {
  meter: PropTypes.any,
  setVirtualMeter: PropTypes.any,
  selectedDate: PropTypes.string,
};
export default VirtualMeterDetail;
